import React from 'react';
import { SkeletonBlock } from './SkeletonBlock';
import { SkeletonText } from './SkeletonText';

interface FormSkeletonProps {
  fields?: number;
  className?: string;
}

export const FormSkeleton: React.FC<FormSkeletonProps> = ({
  fields = 6,
  className = '',
}) => {
  return (
    <div className={`aa-skeleton-form ${className}`} aria-hidden="true">
      {Array.from({ length: fields }).map((_, index) => (
        <div className="aa-skeleton-form-field" key={index}>
          <SkeletonBlock width="30%" height={10} />
          <SkeletonBlock height={42} className="mt-2" />
          {index % 2 === 0 ? <SkeletonText lines={1} className="mt-2" /> : null}
        </div>
      ))}
      <div className="aa-skeleton-form-actions">
        <SkeletonBlock width={120} height={38} radius={10} />
        <SkeletonBlock width={120} height={38} radius={10} />
      </div>
    </div>
  );
};
